export function AiIcon() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8 13.6 8l5.2 1.6-5.2 1.6L12 16.4l-1.6-5.2-5.2-1.6L10.4 8 12 2.8Z" /><path d="m18.3 14 .8 2.6 2.6.8-2.6.8-.8 2.6-.8-2.6-2.6-.8 2.6-.8.8-2.6Z" /></svg>;
}
